import { Injectable, inject } from '@angular/core';
import {ApiService, ToastService} from '../';
import {IPageableProjects, Project, ProjectDetails} from '../../models';
import {TranslateService} from '@ngx-translate/core';
import {HttpResponse} from '@angular/common/http';
import {ProjectDetailsData} from '../../models';
import {ConstructionCosts} from '../../enums';

@Injectable()
export class ProjectService {
    private apiService = inject(ApiService);
    private toastService = inject(ToastService);
    private translateService = inject(TranslateService);

    public getProjects(page: number, pageSize: number, searchTerm?: string, searchCompany?: string, searchStatuses?: string[], searchClassifications?: string[],
                       searchConstructionCosts?: string, searchStartDate?: string, searchEndDate?: string, isAllProject = false): Promise<IPageableProjects> {
        return new Promise((resolve, reject) => {
            let additionalParameters = (searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '');
            additionalParameters += (searchCompany ? `&searchCompanyName=${encodeURIComponent(searchCompany)}` : '');
            additionalParameters += (searchStatuses && searchStatuses.length > 0 ? `&searchStatuses=${encodeURIComponent(searchStatuses.join('||'))}` : '');
            additionalParameters += (searchClassifications && searchClassifications.length > 0 ? `&searchClassifications=${encodeURIComponent(searchClassifications.join('||'))}` : '');

            if (!isAllProject) {
                if (searchStartDate) {
                    additionalParameters += `&startDate=${searchStartDate}`;
                }
                if (searchEndDate) {
                    additionalParameters += `&endDate=${searchEndDate}`;
                }
            }

            if ( searchConstructionCosts) {
                if (searchConstructionCosts === ConstructionCosts.LESS_THAN_10M) {
                    additionalParameters += '&upperBoundConstructionCosts=9999999';
                } else if (searchConstructionCosts === ConstructionCosts.BETWEEN_10M_AND_25M) {
                    additionalParameters += '&lowerBoundConstructionCosts=10000000&upperBoundConstructionCosts=24999999';
                } else if (searchConstructionCosts === ConstructionCosts.BETWEEN_25M_AND_50M) {
                    additionalParameters += '&lowerBoundConstructionCosts=25000000&upperBoundConstructionCosts=50000000';
                } else if (searchConstructionCosts === ConstructionCosts.GREATER_THAN_50M) {
                    additionalParameters += '&lowerBoundConstructionCosts=50000001';
                }
            }

            const endPoint = isAllProject ? 'projects/all' : 'projects';

            this.apiService.get(`/${endPoint}?page=${page}&size=${pageSize}${additionalParameters}`).then((projectResponse: HttpResponse<IPageableProjects>) => {
                projectResponse.body.content = projectResponse.body.content.map(data => new Project(data));
                resolve(projectResponse.body);
            }).catch((error) => {
                this.toastService.openError(error.status, this.translateService.instant('ERRORS.projects_not_updated'));
                reject(error);
            });
        });
    }

    public getProjectDetails(projectId: number): Promise<ProjectDetails> {
        return new Promise((resolve, reject) => {
            this.apiService.get(`/projects/${projectId}/details`).then((projectResponse: HttpResponse<ProjectDetailsData>) => {
                const project: ProjectDetails = new ProjectDetails(projectResponse.body);
                resolve(project);
            }).catch((error) => {
                this.toastService.openError(error.status, this.translateService.instant('ERRORS.project_not_found'));
                reject(error);
            });
        });
    }

    public triggerEmailNotification(): Promise<void> {
        return this.apiService.get(`/projects/notification`);
    }
}
